import React, { PropsWithChildren } from 'react';
import classNames from 'classnames';
import styles from './fix-button-default.module.scss';
import {FixButton} from "@/elements-react/fix-button";

export interface FixButtonDefaultProps extends React.ComponentProps<typeof FixButton> {
  active?: boolean;
  fullWidth: boolean;
  variant?: "default" | "primary" | "neutral" | "text" | "more";
  size?: "default" | "small" | "medium" | "large";
  type?: "button" | "submit" | "reset";
}

export const FixButtonDefault: React.FC<PropsWithChildren<FixButtonDefaultProps>> = ({
  children,
  className,
  active,
  fullWidth = true,
  variant = 'neutral',
  size = 'default',
  type = 'button',
  ...props
}) => {
  return (
    <div className={styles.root}>
      <FixButton
        className={classNames(styles.button, className, { active })}
        variant={variant}
        size={size}
        fullWidth={fullWidth}
        {...props}
      >
        {children}
      </FixButton>
    </div>
  );
};

export default FixButtonDefault;
